const actions = {
    addEmailToList: ({commit}, email) => {
        commit('setEmail', email)
    },
}
export default actions